<template>
    <div>
        <div>
            <zBaseComponent :data="dataPage"/>
        </div>

        <div v-if="!loadingPage">
            <FilterProduct />
        </div>

        <v-container>
            <div 
                v-if="loadingPage"
                class="text-center">
                <v-progress-circular
                    color="primary"
                    indeterminate>
                </v-progress-circular>
            </div>

            <!-- <v-row 
                v-if="loadingPage"
                class="my-10">
                <v-col 
                    md="4"
                    cols="6"
                    v-for="(item, p) in 9"
                    :key="'skeleton' + p">
                    <v-skeleton-loader
                        class="mx-auto border"
                        type="image, article">
                    </v-skeleton-loader>
                </v-col>
            </v-row> -->
        </v-container>
    </div>
    
</template>

<script setup>
    import { ref, watch, onMounted } from 'vue'
    import zBaseComponent from '../components/zBaseComponent'
    import FilterProduct from '@/components/FilterProduct'
    import api from '../api'

    const dataPage = ref({})

    const loadingPage = ref(false)
    
    getPage()

    async function getPage(){
        loadingPage.value = true
        const resPage = await api.get('page/products')
        dataPage.value = resPage.data.data

        document.title = resPage.data.title
        const metaTagTitle = document.querySelector('meta[name="title"]');
        if (metaTagTitle) {
            metaTagTitle.setAttribute('content', resPage.data.title);
        }
        loadingPage.value = false
    }

    onMounted(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    })
</script>